import * as yup from 'yup';
import { translateHelpers } from '../../../utils/helpers';

export const rules = yup.object().shape({
  password: yup
    .string()
    .required({
      message: 'required',
      field: 'password',
      params: {
        key: translateHelpers.t('common', 'Password'),
      },
    }),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password'), null], {
      field: 'passwordConfirm',
      message: 'match',
      params: {
        key: translateHelpers.t('common', 'Passwords'),
      },
    })
    .required({
      message: 'required',
      field: 'passwordConfirm',
      params: {
        key: translateHelpers.t('common', 'Password confirm'),
      },
    }),
});
